import { AccountBarChart } from './components/AccountBarChart'
import { parseDataChart } from './helpers/parseDataChart'

import type { PreviewBarChartProps } from './types'

import * as S from './styles'

export const PreviewBarChart = ({ data }: PreviewBarChartProps) => {
  if (!data) return null

  const parsedData = parseDataChart(data)

  if (!parsedData.length) return null

  /** As contas são identificadas pela legenda (os painéis não repetem o nome no eixo X) */
  const legendItems = [
    { name: 'Budget', color: parsedData[0].budget.color },
    ...parsedData.map((item) => ({ name: item.name, color: item.week5.color }))
  ]

  return (
    <>
      <S.ChartsRow>
        {parsedData.map((account) => (
          <AccountBarChart key={account.name} account={account} />
        ))}
      </S.ChartsRow>

      <S.LegendContainer>
        {legendItems.map((item) => (
          <S.LegendItem key={item.name}>
            <S.LegendColorBox color={item.color} />
            <S.LegendLabel>{item.name}</S.LegendLabel>
          </S.LegendItem>
        ))}
      </S.LegendContainer>
    </>
  )
}
